import React from 'react';
import { TextField } from '@mui/material';

function NumberField(props) {
  return (
    <TextField
      variant="outlined"
      type="number"
      size="small"
      fullWidth
      {...props}
      sx={{
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(0, 0, 0, 0.23)',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(0, 0, 0, 0.87)',
        },
        ...props.sx,
      }}
      InputProps={{
        ...props.InputProps,
        inputProps: {
          step: 'any',
          ...props.InputProps?.inputProps,
          onWheel: (e) => e.target.blur(),
        },
      }}
    />
  );
}

export default NumberField;
